import { useUserContext } from '../contexts/UserContext';
import { PermissionEnum } from '../enums/PermissionEnum';
import { RoleName } from '../enums/RoleNameEnm';

export const usePermissions = () => {
  const { getPermissions, userInfoState } = useUserContext();

  const hasPermission = (permission: PermissionEnum | PermissionEnum[]) => {
    if (typeof permission === 'string') {
      if (getPermissions().includes(permission)) {
        return true;
      } else {
        const highLevelPermission = `all::${(permission as string).split('::')[1]}`;
        return getPermissions().includes(highLevelPermission);
      }
    } else if (Array.isArray(permission)) {
      if (permission.some((permission) => getPermissions().includes(permission))) {
        return true;
      } else {
        return permission.some((permission) => {
          const highLevelPermission = `all::${(permission as string).split('::')[1]}`;
          return getPermissions().includes(highLevelPermission);
        });
      }
    }
    return false;
  };

  const hasRoles = (roles: RoleName | RoleName[]): boolean => {
    const currentRoleName =
      userInfoState?.roleName ?? (localStorage.getItem('roleName') as RoleName | null);

    if (!currentRoleName) return false;

    return Array.isArray(roles) ? roles.includes(currentRoleName) : currentRoleName === roles;
  };

  return { hasPermission, hasRoles };
};
